<template>
  <div class="difficulties">
    <template v-for="difficulty in sortedDifficulties">
      <div class="difficulty">
        <h3>{{difficulty.name}}</h3>
        <div class="meter" :class="getMeterClasses(difficulty)">
          <div class="progress"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Difficulties',
  props: {
    difficulties: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    getMeterClasses (difficulty) {
      return {
        [`color-${difficulty.color}`]: difficulty.color,
        'meter-half': difficulty.difficulty === 'half'
      }
    }
  },
  computed: {
    sortedDifficulties () {
      const difficulties = []
      for (const key in this.difficulties) {
        let name = key
        switch (name) {
          case 'body':
            name = 'Krop'
            break
          case 'brain':
            name = 'Hjerne'
            break
          case 'demographics':
            name = 'Omverden'
            break
        }
        difficulties.push({
          name: name,
          color: this.difficulties[key].color,
          difficulty: this.difficulties[key].difficulty > 0.5 ? 'full' : 'half'
        })
      }
      return difficulties
    }
  }
}
</script>

<style lang="scss" scoped>
.difficulties {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}
header {
  padding-right: 1rem;
}
h3, label {
  margin-bottom: 0px;
}
.difficulty {
  flex: 1;
  margin: 0rem 1rem;
  display: flex;
  align-items: center;

  &:first-child {
    margin-left: 0;
  }
}
.meter {
  border: 1px solid;
  border-radius: 1000px;
  height: 1rem;
  flex: 1;
  margin-left: 1rem;
  display: flex;

  
  .progress {
    background-color: currentcolor;
    width: 100%;
    height: 100%;
  }
  &-half {
    .progress {
      width: 50%;
      height: 100%;
    }
  }
}
.color {
  &-yellow {
    color: #f6bf6a;
  }
  &-green {
    color: #16c05e;
  }
  &-red {
    color: #be3a4d;
  }
}
</style>


// WEBPACK FOOTER //
// Difficulties.vue?0faada7c